import { render } from "./CopyData.vue?vue&type=template&id=180dabf8&scoped=true"
import script from "./CopyData.vue?vue&type=script&lang=js"
export * from "./CopyData.vue?vue&type=script&lang=js"

import "./CopyData.vue?vue&type=style&index=0&id=180dabf8&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180dabf8"]])

export default __exports__